import gql from 'graphql-tag';

export const getUsersByNameQuery = gql`
  query GetUsersByName($organisationId: String!, $name: String) {
    getUsersByName(organisationId: $organisationId, name: $name) {
      userId,
      firstName,
      lastName,
      imageUrl
    }
  }
`;

const getUsersByName = () => ({
  query: getUsersByNameQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: ({ organisationId, name }) => ({
    organisationId,
    name
  })
});

export default getUsersByName;